import { Expose, Type } from 'class-transformer'
import { BookType } from './BookType'

export class BookListType {
  @Expose()
  @Type(() => BookType)
  data: BookType[]

  @Expose()
  page: number

  @Expose()
  total: number
}
